import { Component, Input } from '@angular/core';

@Component({
    selector: 'image',
    templateUrl: 'image.component.html'
})
export class PreviewImageComponent {
    image = {
        src: '',
        title: '',
        alt: '',
        caption: ''
    };
    mobile = {
        src: '',
        caption: ''
    };

    @Input('slide') 
    set slide(slide) {
        if( slide ) {
            this.setImages(slide);
        }
    };

    constructor() {}
    setImages(slide) {
        const images = slide.images;
        if( images.length ) {
            const img = images[0];
            Object.assign(this.image, {
                src: this.getSrc(img),
                title: img.title,
                alt: img.alt,
                caption: img.caption
            });
        }
        const mobileImages = slide.imagesMobile;
        if( mobileImages.length ) {
            const mobileImg = mobileImages[0];
            Object.assign(this.mobile, {
                src: this.getSrc(mobileImg, 'mobile'),
                caption: mobileImg.caption
            });
        } else {
            this.mobile.caption = this.image.caption;
        }
    }
    getSrc(img, size = '') {
        if( size == 'mobile' ) {
            return img.sizes.mobile ? img.sizes.mobile.urlWithParams : img.sizes.medium.urlWithParams;
        }
        return img.sizes.desktop ? img.sizes.desktop.urlWithParams : img.sizes.full.urlWithParams;
    }
}